export default __webpack_public_path__ + "static/media/tour-access-lock-open.3cfee43a.svg";